import { render, staticRenderFns } from "./AutoCheckMot.vue?vue&type=template&id=220beef3&"
import script from "./AutoCheckMot.vue?vue&type=script&lang=js&"
export * from "./AutoCheckMot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports